import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[appOnlyAlphabets]',
  standalone: true
})
export class OnlyAlphabetsDirective {

  @HostListener('keydown', ['$event'])
  allowOnlyAlphabets(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);

    // Allow alphabets (A-Z, a-z), backspace, and space
    if (
        charCode !=undefined &&
        !(charCode >= 65 && charCode <= 90) && // A-Z
        !(charCode >= 97 && charCode <= 122) && // a-z
        event.key !== 'Backspace' &&
        event.key !== ' '
    ) {
      event.preventDefault();
    }
  }

}
